/** @jsxImportSource react/jsx-runtime */
/** @jsxRuntime classic */

import React from "react";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";
import moment from "moment";
import logo from "../../assests/authLogo.png";
import { pdfjs, Font } from "pdfjs-dist";
import pdfWorker from "pdfjs-dist/build/pdf.worker.entry";

// Create styles
const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    flexWrap: "wrap",
    width: "100%",
  },
  cellfooter: {
    // flexDirection: "row",
    // flexWrap: "wrap",
    width: "100%",
  },
  cell: {
    width: "48%",
    borderWidth: 1,
    borderColor: "#000",
    padding: 5,
  },
  cell4: {
    width: "20%",
    borderWidth: 1,
    borderColor: "#000",
    padding: 5,
  },
  cell5: {
    width: "40%",
    borderWidth: 1,
    borderColor: "#000",
    padding: 5,
  },
  cell6: {
    width: "20%",
    borderWidth: 1,
    borderColor: "#000",
    padding: 5,
  },
  tc: {
    textAlign: "center",
  },
  tr: {
    textAlign: "right",
  },
  headerCell: {
    fontWeight: "bold",
  },
  headText: {
    margin: 4,
  },
  page: {
    flexDirection: "column",
    alignItems: "stretch",
    backgroundColor: "#fff",
    padding: 30,
    margin: 12,
    marginRight: 10,
    // fontFamily: "Gesta-Medium",
  },
  row: {
    flexDirection: "row",
    flexWrap: "wrap",
    marginBottom: 10,
  },
  col: {
    width: "50%",
  },
  col2: {
    width: "100%",
  },
  section: {
    fontSize: 10,
  },
  imgstyle: {
    width: "50%",
  },
  textstyle: {
    color: "#032037d4",
    fontSize: 12,
  },
  font2: {
    fontSize: 10,
    fontWeight: "bold",
  },
  color1: {
    backgroundColor: "#1c90bed6",
    color: "white",
  },
  textstyle1: {
    color: "#005598",
    fontSize: 15,
    fontWeight: "bold",
    margingLeft: 12,
  },
  section2: {
    backgroundColor: "#003e6a",
    color: "white",
    fontSize: 13,
    fontWeight: "bold",
    padding: 5,
  },
  mt: { marginTop: -5 },
  mt1: { marginTop: 0 },
  mb: { marginBottom: 6 },
  mb1: { marginBottom: 0 },
  mb2: { marginBottom: 20 },
  ml: { marginLeft: 6 },
  mr: { marginRight: 6 },
  section3: {
    width: "1o0%",
    color: "#005598",
    fontSize: 15,
    fontWeight: "bold",
    margingLeft: 10,
  },
  textBold: {
    fontWeight: 500,
    fontSize: 12,
  },
  ht: {
    height: "26%",
    maxHeight: "26%",
  },
});

function convertCurrencyFormat(inputAmount) {
  // Check if the inputAmount is a valid number
  if (typeof inputAmount !== "number" || isNaN(inputAmount)) {
    return "Invalid input amount";
  }

  // Determine if the inputAmount is negative
  const isNegative = inputAmount < 0;

  // Convert the absolute value of the numeric amount into the desired format
  const formattedAmount = Math.abs(inputAmount).toFixed(2);

  // Replace the decimal separator (dot) with a comma
  // and the thousands separator (comma) with a space
  let result = `${formattedAmount.replace(".", ",").replace(/\B(?=(\d{3})+(?!\d))/g, " ")} $`;

  // Add parentheses for negative amounts
  if (isNegative) {
    result = `(${result})`;
  }

  return result;
}

function convertCurrencyFormatwithoutdollar(inputAmount) {
  // Check if the inputAmount is a valid number
  if (typeof inputAmount !== "number" || isNaN(inputAmount)) {
    return "Invalid input amount";
  }
  const formattedAmount = inputAmount.toFixed(2);
  return `${formattedAmount.replace(".", ",").replace(/\B(?=(\d{3})+(?!\d))/g, " ")}`;
}

// Create Document Component
const MyDocument = ({ data }) => (
  <Document>
    {Object.keys(data).length !== 0 && (
      <Page size="A4" style={styles.page}>
        <View style={[styles.row]}>
          <View style={styles.col}>
            <View style={styles.section}>
              <Image src={logo} style={styles.imgstyle} />
            </View>
            <View style={[styles.section]}>
              <Text style={styles.textstyle}>
                200, avenue de la Cathédrale{" "}
              </Text>
            </View>
            <View style={[styles.section]}>
              {" "}
              <Text style={styles.textstyle}>Winnipeg (Manitoba) R2H 0H7</Text>
            </View>

            <View style={[styles.section]}>
              {" "}
              <Text style={styles.textstyle}>1-204-233-0210</Text>
            </View>
            <View style={[styles.section]}>
              {" "}
              <Text style={styles.textstyle}>
                Numéro d'entreprise : 106953110
              </Text>
            </View>
          </View>
          <View style={styles.col}>
            <View style={[styles.headerCell]}>
              <Text style={[styles.textstyle1, styles.ml]}>Facture</Text>
            </View>
            <View style={[styles.container, styles.headText, styles.font2]}>
              <View style={[styles.cell, styles.headerCell, styles.color1]}>
                <Text>Facture</Text>
              </View>
              <View style={[styles.cell, styles.headerCell]}>
                <Text>{data.invoicenumber}</Text>
              </View>
              <View style={[styles.cell, styles.color1]}>
                <Text>Date</Text>
              </View>
              <View style={styles.cell}>
                <Text>{moment(data.ses_invoicedate).format("YYYY/MM/DD")}</Text>
              </View>
            </View>
          </View>
        </View>

        {/*second part  */}

        <View style={styles.row}>
          <View style={styles.col}>
            <View style={[styles.section, styles.section2]}>
              <Text style={[styles.textBold]}>Adresse:</Text>
            </View>
            <View style={styles.section}>
              <Text>{data.fullname}</Text>
            </View>
            <View style={styles.section}>
              <Text>{data.address1_composite}</Text>
            </View>
            {/* <View style={styles.section}>
            <Text>{data.address1_composite}</Text>
          </View> */}
            <View style={styles.section}>
              <Text>{data.telephone1}</Text>
            </View>
            <View style={styles.section}>
              <Text>{data.emailaddress1}</Text>
            </View>
          </View>
        </View>

        {/* third part */}
        <View style={styles.row}>
          <View
            style={[
              styles.section,
              styles.section2,
              styles.col2,
              styles.mb,
              styles.ht,
            ]}
          >
            <Text></Text>
            <Text></Text>
            <Text></Text>
          </View>

          <View style={styles.row}>
            <View style={[styles.col, styles.section]}>
              {" "}
              <Text style={{ fontWeight: "800" }}>
                Montant total: {"                 "}
                {convertCurrencyFormat(data.totalamount)}
              </Text>
            </View>
            <View style={[styles.col, styles.section]}>
              {" "}
              <Text>
                Numéro de facture: {"           "}
                {data.invoicenumber}
              </Text>
            </View>
          </View>
          <View style={styles.row}>
            <View style={[styles.col, styles.section]}>
              {" "}
              <Text>
                Solde dû le:{"                    "}
                {moment(data.duedate).format("YYYY/MM/DD")}
              </Text>
            </View>
            <View style={[styles.col, styles.section]}>
              {" "}
              <Text>
                Session:{"                             "}
                {
                  data[
                    "_ses_term_value@OData.Community.Display.V1.FormattedValue"
                  ]
                }
              </Text>
            </View>
          </View>
          <View style={styles.row}>
            <View style={[styles.col, styles.section]}>
              {" "}
              <Text>
                Nom de l'étudiant: {"         "}
                {data.ses_studentname}{" "}
              </Text>
            </View>
            <View style={[styles.col, styles.section]}>
              {" "}
              <Text>
                N° étudiant USB:{"               "}{" "}
                {data.ses_institutionstudentid}
              </Text>
            </View>
          </View>
        </View>

        {/* fourth part */}
        <View style={styles.row}>
          <View
            style={[
              styles.section2,
              styles.col2,
              styles.container,
              styles.font2,
            ]}
          >
            <Text>Détail</Text>
          </View>
          <View style={[styles.container, styles.font2, styles.mb1]}>
            <View style={[styles.cell4, styles.headerCell]}>
              <Text>Description</Text>
            </View>
            <View style={[styles.cell4, styles.headerCell]}>
              <Text>Nº de classe</Text>
            </View>
            <View style={[styles.cell4, styles.headerCell]}>
              <Text>Quantité</Text>
            </View>
            <View style={[styles.cell4, styles.headerCell]}>
              <Text>Cout unitaire</Text>
            </View>
            <View style={[styles.cell4, styles.headerCell]}>
              <Text>Sous-total</Text>
            </View>
            {data &&
              data?.productDetails &&
              data?.productDetails?.map((ele, index) => (
                <React.Fragment key={index}>
                  <View style={[styles.cell4]}>
                    <Text>{ele.name}</Text>
                  </View>
                  <View style={styles.cell4}>
                    <Text>{ele.ses_institutionclassid}</Text>
                  </View>
                  <View style={[styles.cell4, styles.tc]}>
                    <Text>
                      {convertCurrencyFormatwithoutdollar(ele.quantity)}
                    </Text>
                  </View>
                  <View style={[styles.cell4, styles.tc]}>
                    <Text>{convertCurrencyFormat(ele.priceperunit)}</Text>
                  </View>
                  <View style={[styles.cell4, styles.tr]}>
                    <Text>{convertCurrencyFormat(ele.extendedamount)}</Text>
                  </View>
                </React.Fragment>
              ))}

            <View
              style={[
                styles.cellfooter,
                styles.headText,
                styles.font2,
                styles.mt1,
              ]}
            >
              <View style={[styles.container, { justifyContent: "flex-end" }]}>
                <View style={[styles.cell5, styles.tc]}>
                  <Text>Sous-total</Text>
                </View>
                <View style={[styles.cell6, styles.tr]}>
                  <Text>{convertCurrencyFormat(data.totallineitemamount)}</Text>
                </View>
              </View>
              <View style={[styles.container, { justifyContent: "flex-end" }]}>
                <View style={[styles.cell5, styles.headerCell, styles.tc]}>
                  <Text>Montant taxes total </Text>
                </View>
                <View
                  style={[
                    styles.cell6,
                    styles.headerCell,
                    styles.trl,
                    ,
                    styles.tr,
                  ]}
                >
                  <Text>{convertCurrencyFormat(data.totaltax)}</Text>
                </View>
              </View>

              <View style={[styles.container, { justifyContent: "flex-end" }]}>
                <View style={[styles.cell5, styles.tc]}>
                  <Text>Montant total dû</Text>
                </View>
                <View style={[styles.cell6, styles.tr]}>
                  <Text>{convertCurrencyFormat(data.totalamount)}</Text>
                </View>
              </View>
            </View>
          </View>
        </View>
      </Page>
    )}
  </Document>
);

export default MyDocument;
